import React from "react";
import {
  Badge,
  Box,
  IconButton,
  styled,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import KeyboardDoubleArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import {
  BodySmall,
  H7TitleLarge,
} from "../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../components/StyledComponents/Buttons/AuradineButtons.js";
import CaseManagementFilters from "./CaseManagementFilters.js";
import { useTheme } from "../../ThemeContext/ThemeContext.js";

const CustomBadge = styled(Badge)(({ colors }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: colors?.text?.primary,
    color: colors?.primary?.contrastText,
    fontSize: "0.75rem", // Optional: Adjust font size
    padding: "0.25rem", // Optional: Adjust padding
  },
}));

export const CaseManagementHeader = React.memo((props) => {
  const { colors } = useTheme();
  const {
    gridRef,
    totalCount,
    selectedCases,
    setRightSidePanelOpen,
    rightSidePanelOpen,
  } = props;

  return (
    <Box
      className={"table-container-header"}
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <CustomBadge
        colors={colors}
        badgeContent={totalCount}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{}}
        max={1000000}
      >
        <Box pr={3}>
          <H7TitleLarge>Case List</H7TitleLarge>
        </Box>
      </CustomBadge>
      <Box
        display={"flex"}
        flexDirection={"row"}
        gap={2}
        alignItems={"center"}
      >
        <CaseManagementFilters />
        <Tooltip
          title={
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="row"
              sx={{ textAlign: "center" }}
            >
              <BodySmall style={{ color: "#fff" }}>
                {selectedCases && selectedCases.length === 1
                  ? "Click to show case details"
                  : "Select exactly one case to view details"
                }
              </BodySmall>
            </Box>
          }
          arrow
        >
          <span>
            <StyledIconButton
              colors={colors}
              disabled={!selectedCases || selectedCases.length === 0 || selectedCases.length !== 1}
              onClick={() => setRightSidePanelOpen(!rightSidePanelOpen)}
            >
              <KeyboardDoubleArrowLeftOutlinedIcon
                fontSize={"medium"}
                sx={{
                  color:
                    !selectedCases || selectedCases.length === 0 || selectedCases.length !== 1
                      ? colors?.text?.disabled
                      : colors?.text?.muted,
                  transform: rightSidePanelOpen
                    ? "rotate(0deg)"
                    : "rotate(180deg)",
                }}
              />
            </StyledIconButton>
          </span>
        </Tooltip>
      </Box>
    </Box>
  );
});
